import React from 'react';
import { FadeIn } from './FadeIn';
export function TheProblem() {
  return <section className="bg-brand-green text-brand-cream py-24 px-6 border-y border-brand-gold/20" data-id="element-175">
      <div className="max-w-4xl mx-auto" data-id="element-176">
        <FadeIn data-id="element-177">
          <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-178">
            <div className="md:w-1/3" data-id="element-179">
              <div className="w-24 h-24 bg-brand-dark rounded-full flex items-center justify-center border border-brand-gold/30 mb-6 mx-auto md:mx-0" data-id="element-180">
                <svg className="w-10 h-10 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-181">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-182" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-center md:text-left text-brand-gold" data-id="element-183">
                Una Fuga de Capital
              </h2>
            </div>

            <div className="md:w-2/3 space-y-6 text-lg font-light text-brand-cream/90" data-id="element-184">
              <p data-id="element-185">
                <strong className="font-semibold text-brand-cream" data-id="element-186">
                  El agotamiento crónico no es una medalla de honor, es una fuga
                  de capital.
                </strong>
              </p>
              <p data-id="element-187">
                Cuando tu cuerpo está drenado y tu mente está en modo
                supervivencia (cortisol alto), pierdes la capacidad de ver
                oportunidades claras. Tomas decisiones financieras por impulso o
                miedo, te paralizas ante los riesgos y terminas quemando tu
                activo más valioso: tú mismo.
              </p>
              <p className="text-xl font-serif italic text-brand-gold pt-4 border-t border-brand-gold/20" data-id="element-188">
                "Si logras el dinero pero pierdes tu salud o tu centro, no eres
                libre; simplemente has cambiado de cárcel."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}